import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import useStores from 'shared/hooks/use-stores';
import { PasswordForm } from 'src/payments/signup/views/password-form/password-form';
import useInstoreCart from 'hooks/use-instore-cart';
import { useLogin } from 'src/payments/instore-cart/views/login-form/use-login';
import { LoginSteps } from 'src/payments/state/instore-cart';
import { useTurnstile } from 'src/components/turnstile';
import { TURNSTILE_ACTIONS, TurnstileAction } from 'shared/constants/turnstile';

type PasswordFormWrapperProps = {
  showToolTip: boolean;
};

export function PasswordFormWrapper({ showToolTip = false }: PasswordFormWrapperProps): JSX.Element {
  const { UI } = useStores();
  const dutchiePayEnrollment = useDutchiePayEnrollment();
  const InstoreCart = useInstoreCart();
  const flags = useFlags();

  const { login } = useLogin();
  const onForgotPassword = (): void => InstoreCart.setCurrentLoginStep(LoginSteps.RESET_PASSWORD);
  const onLearnMore = (): void => UI.openDutchiePayLearnMoreModal();
  const onBackClick = (): void => InstoreCart.setCurrentLoginStep(LoginSteps.EMAIL);

  const isTurnstileEnabled = flags['growth.ecomm.login-turnstile-enable.rollout'];

  const { TurnstileComponent, executeAndWaitForToken } = useTurnstile({
    size: 'flexible',
    action: TURNSTILE_ACTIONS.LOGIN as TurnstileAction,
  });

  const handleSubmit = async ({ password }: { password: string }): Promise<void> => {
    if (isTurnstileEnabled) {
      try {
        const token = await executeAndWaitForToken();
        await login({ password, turnstileToken: token });
      } catch (error) {
        console.error(error);
      }
    } else {
      await login({ password, turnstileToken: '' });
    }
  };

  return (
    <>
      <PasswordForm
        userEmail={dutchiePayEnrollment.userEmail}
        onSubmit={handleSubmit}
        onForgotPassword={onForgotPassword}
        onLearnMore={onLearnMore}
        showToolTip={showToolTip}
        onBackClick={onBackClick}
      />
      {isTurnstileEnabled && <TurnstileComponent />}
    </>
  );
}
